module.exports = __webpack_public_path__ + "static/media/tecnoglass3.9ce009fa.jpg";